import { render, staticRenderFns } from "./notifications-dialog.vue?vue&type=template&id=58c2d772&scoped=true&"
import script from "./notifications-dialog.vue?vue&type=script&lang=js&"
export * from "./notifications-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2d772",
  null
  
)

export default component.exports